import ReactPDF, { View } from '@react-pdf/renderer';
import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
// import moment from 'moment';
// import MathUtil from 'src/util/MathUtil';
import SaltwerxBrineLeaseProps from 'src/models/leaseTemplateProps/SaltwerxBrineLeaseProps';
// tslint:disable: max-line-length

// Font.register({
//     family: 'Lato',
//     fonts: [
//         {
//             src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh7USew-FGC_p9dw.ttf',
//             fontWeight: 300,
//         },
//         {
//             src: 'https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHvxk6XweuBCY.ttf',
//             fontWeight: 400,
//         },
//         {
//             src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf',
//             fontWeight: 700,
//         },
//     ],
// });

const styles = StyleSheet.create({
    pageMain: {
        backgroundColor: '#FFFFFF',
        paddingTop: 50,
        paddingBottom: 70,
        paddingHorizontal: 60,
        fontFamily: 'Helvetica',
    },
    page: {
        backgroundColor: '#FFFFFF',
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 80,
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Times-Bold',
    },
    fontNormal: {
        fontFamily: 'Times-Roman',
        fontWeight: 'normal',
        fontSize: 9,
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    mb2: {
        marginBottom: 20,
    },
    mr1: {
        marginRight: 5,
    },
    mr2: {
        marginRight: 20,
    },
    ml1: {
        marginLeft: 5,
    },
    ml2: {
        marginLeft: 20,
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },

    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Times-Roman',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 'bold',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '18',
        fontWeight: 'bold',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Times-Bold',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    lineHeight: {
        lineHeight: 1.5,
    },
    h2: {
        fontSize: 12,
    },
    h3: {
        fontSize: 10,
    },
    lessorLabel: {
        width: '75px',
        fontSize: 9,
        textAlign: 'right',
        marginRight: '4',
        fontWeight: 'bold',
    },
    lessorData: {
        maxWidth: '20%',
        fontSize: 9,
    },
    footerText: {
        color: 'grey',
        fontSize: 9,
    },
    ownershipColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
    },
    bonusColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
        paddingRight: 15,
    },
    dudleyInfo: {
        position: 'absolute',
        bottom: '50px',
        left: '60px',
    },
    approvedBy: {
        position: 'absolute',
        bottom: '145px',
        left: '60px',
    },
});

interface ISaltwerxOOPProps {
    hideDialog?: () => void;
    leaseProps?: SaltwerxBrineLeaseProps;
}

const SaltwerxOOP = (props: ISaltwerxOOPProps) => {
    const dispatch = useDispatch();

    return (
        <Dialog title="Order of Payment" dialogName={DialogList.OOP_VIEWER} onCloseDialog={() => dispatch(actions.layout.hideDialog())}>
            <ReactPDF.PDFViewer style={{ height: '85vh', width: '70vw' }}>
                <Document>
                    <Page size="LEGAL" style={styles.pageMain}>
                        <View
                            fixed={true}
                            style={{
                                borderBottom: '1',
                                borderBottomStyle: 'solid',
                                borderBottomColor: 'black',
                            }}
                        >
                            <View style={{ marginTop: '15px' }}>
                                <Text
                                    style={{
                                        fontSize: 13,
                                        textAlign: 'center',
                                    }}
                                >
                                    {props?.leaseProps?.lesseeName}
                                </Text>
                                <Text style={{ fontSize: 23, textAlign: 'center', fontWeight: 700 }}>ORDER OF PAYMENT</Text>
                            </View>

                            <View
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    marginTop: '10px',
                                    marginBottom: '10px',
                                }}
                            >
                                <Text style={{ fontSize: 10 }}>Date: </Text>
                                <Text style={{ fontSize: 10, textDecoration: 'underline' }}>{props.leaseProps.leaseDateFull}</Text>
                            </View>
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={[{ fontSize: 10 }, styles.lineHeight]}>
                                Subject to approval of the agreement associated herewith and title confirmation by{' '}
                                <Text style={[styles.bold]}>{props?.leaseProps?.lesseeName}</Text>, will cause payment as indicated herein by check
                                within 30 Days (banking days) of its receipt of the original of this Order of Payment and the associated agreement.
                                The copy of this Order of Payment is to be retained by payee. No default for non-payment may be claimed by payee
                                during said 30 Days (banking days) period.
                            </Text>
                            <Text style={[{ fontSize: 10, marginTop: '5px' }, styles.lineHeight]}>
                                If during such period it is discovered that payee owns more or less than the net interest defined herein,{' '}
                                <Text style={[styles.bold, { fontSize: 10}]}>{props?.leaseProps?.lesseeName}</Text> will increase or reduce the consideration payable
                                hereunder proportionate to the interest deemed to be owned by payee, based on a lease bonus of{' '} 
                                {props?.leaseProps?.primaryRentalTotal} {props?.leaseProps?.primaryRentalBonusUnits}. Payee represents he/she has a full understanding of the risks involved
                                in leasing property for oil and gas development and that payee has read and understands the terms and provisions of
                                the agreement associated herewith. Further, payee represents this is an arm's length transaction entered into by payee
                                as a result of his/her own free act and will and <Text style={[styles.bold]}>{props?.leaseProps?.lesseeName}</Text>{' '}
                                and/or anyone acting on its behalf has made no representations of value or exerted any duress or coercion.
                            </Text>
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={{ fontSize: 10 }}>
                                Pay to
                                <Text style={{ fontSize: 10, fontWeight: 700 }}> {props?.leaseProps?.ownersOnDocument} </Text>
                                in the amount of
                            </Text>
                        </View>

                        <View
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                borderBottom: '1',
                                borderBottomStyle: 'dashed',
                                borderBottomColor: 'black',
                            }}
                        >
                            <Text style={[{ fontSize: 10 }]}>{props?.leaseProps?.primaryRentalTotalWords}</Text>
                            <Text style={{ fontSize: 10, marginBottom: '5px' }}>( {props?.leaseProps.primaryRentalTotal} )</Text>
                        </View>

                        <View style={{ marginTop: '10px' }}>
                            <Text style={{ fontSize: 10 }}>
                                Address:{' '}
                                <Text style={{ fontSize: 10, fontWeight: 700, marginLeft: '10px' }}>{props?.leaseProps?.ownersAddressOnDocument}</Text>
                            </Text>
                        </View>

                        <View
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                border: '1px solid black',
                                justifyContent: 'space-around',
                                marginTop: '15px',
                            }}
                        >
                            <View style={{ borderRight: '1px solid black', height: '50px', paddingRight: '15px' }}>
                                <Text style={{ fontSize: 10, fontWeight: 700 }}>PAYEE SOCIAL SECURITY NO.</Text>
                            </View>
                            <View style={{ height: '50px' }}>
                                <Text style={{ fontSize: 10, fontWeight: 700 }}>STATE</Text>
                                <Text style={{ fontSize: 10, fontWeight: 700, marginTop: '5px' }}>{props?.leaseProps?.locationState}</Text>
                            </View>
                            <View style={{ borderRight: '1px solid black', height: '50px' }} />
                            <View style={{ height: '50px' }}>
                                <Text style={{ fontSize: 10, fontWeight: 700 }}>COUNTY</Text>
                                <Text style={{ fontSize: 10, fontWeight: 700, marginTop: '5px' }}>{props.leaseProps.locationCounties}</Text>
                            </View>
                            <View style={{ borderLeft: '1px solid black', height: '50px', paddingLeft: '15px' }}>
                                <Text style={{ fontSize: 10, fontWeight: 700 }}>DLC LEASE #</Text>
                                <Text style={{ fontSize: 10, fontWeight: 700, marginTop: '5px' }}> {props?.leaseProps?.leaseNumber} </Text>
                            </View>
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={{ fontSize: 10 }}>
                                This payment is for an Oil and Gas Lease dated {props?.leaseProps?.leaseDateFull}, which covers {props?.leaseProps?.originalGrossAcres} gross acres, more or less,
                                and {props?.leaseProps.netAcres} net acres, more or less.
                            </Text>
                        </View>

                        <View style={{ display: 'flex', flexDirection: 'row', marginTop: '15px' }}>
                            <Text style={{ fontSize: 10 }}>Completed By Signature: </Text>
                            <View style={{ marginRight: '10px', marginLeft: '10px' }}>
                                <Text style={{ fontSize: 10 }}>____________________________________</Text>
                                <Text style={{ fontSize: 10 }}>{props?.leaseProps?.leasedBy}</Text>
                            </View>
                        </View>

                        <View style={{ marginTop: '15px' }}>
                            <Text style={[{ fontSize: 10 }, styles.lineHeight]}>
                                By signing below, Lessor herein accepts and acknowledges their understanding of the amount of lease bonus to be
                                delivered is calculated based on the proportionate net mineral ownership deemed to be owned by Lessor under <Text style={[styles.bold]}>{props?.leaseProps?.lesseeName}</Text> Lease
                                #<Text style={{ fontSize: 10, fontWeight: 700, marginTop: '5px' }}> {props?.leaseProps?.leaseNumber} </Text>, calculated
                                at {props?.leaseProps?.primaryRentalTotal} per net mineral acre. Additionally,
                                said payment shall be considered full and adequate consideration rendered by <Text style={[styles.bold]}>{props?.leaseProps?.lesseeName}</Text> for 
                                said lease.
                            </Text>
                        </View>

                        <View>
                            <View style={{ marginTop: '15px', display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                <Text style={{ fontSize: 10 }}>Lessor's Signature: </Text>

                                <View style={{ margin: '0 15px' }}>
                                    <Text style={{ fontSize: 10 }}>________________________________________________</Text>
                                    <Text style={{ fontSize: 10 }}>{props?.leaseProps?.acknowledgements?.[0]?.signatureBlocks?.[0]?.ownerName || ' '}</Text>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 10 }}>Date: </Text>
                                    <Text style={{ fontSize: 10 }}>____________________</Text>
                                </View>
                            </View>
                            <View style={{ marginTop: '25px', display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                <Text style={{ fontSize: 10 }}>Lessor's Signature: </Text>

                                <View style={{ margin: '0 15px' }}>
                                    <Text style={{ fontSize: 10 }}>________________________________________________</Text>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 10 }}>Date: </Text>
                                    <Text style={{ fontSize: 10 }}>____________________</Text>
                                </View>
                            </View>
                            <View style={{ marginTop: '25px', display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                <Text style={{ fontSize: 10 }}>Lessor's Signature: </Text>

                                <View style={{ margin: '0 15px' }}>
                                    <Text style={{ fontSize: 10 }}>________________________________________________</Text>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 10 }}>Date: </Text>
                                    <Text style={{ fontSize: 10 }}>____________________</Text>
                                </View>
                            </View>
                            <View style={{ marginTop: '25px', display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                <Text style={{ fontSize: 10 }}>Lessor's Signature: </Text>

                                <View style={{ margin: '0 15px' }}>
                                    <Text style={{ fontSize: 10 }}>________________________________________________</Text>
                                </View>

                                <View style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Text style={{ fontSize: 10 }}>Date: </Text>
                                    <Text style={{ fontSize: 10 }}>____________________</Text>
                                </View>
                            </View>
                        </View>

                        <View style={[styles.approvedBy, { width: '500px' }]}>
                            <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                <Text style={{ fontSize: 10 }}>Approved By: </Text>
                                <Text style={{ fontSize: 10, marginLeft: '15px' }}>________________________________________________</Text>
                            </View>
                            <View style={{ borderBottom: '2px solid black', marginTop: '10px' }} />
                        </View>

                        <View style={styles.dudleyInfo}>
                            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <View style={{ width: '30%' }}>
                                    <Text style={[styles.bold, styles.h3]}>Forward To:</Text>
                                    <Text style={{ fontSize: 10 }}>Dudley Land Company</Text>
                                    <Text style={{ fontSize: 10 }}>agent on behalf of Saltwerx, LLC</Text>
                                    <Text style={{ fontSize: 10 }}>817 Avenue A</Text>
                                    <Text style={{ fontSize: 10 }}>Katy Texas, 77493</Text>
                                    <Text style={{ fontSize: 10 }}>LPR#{props?.leaseProps?.leaseNumber}</Text>
                                </View>
                                <View style={{ display: 'flex', flexDirection: 'row', width: '60%', marginLeft: '20px' }}>
                                    <View style={{ height: '75px', width: '75px', border: '1px solid black' }}>
                                        <Text style={{ fontSize: 10, paddingTop: '15px' }}>FOR INTERNAL USE ONLY</Text>
                                    </View>
                                    <View>
                                        <View
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                height: '25px',
                                                width: '250px',
                                                justifyContent: 'space-between',
                                                border: '1px solid black',
                                                borderLeft: '0px',
                                                borderBottom: '0px',
                                            }}
                                        >
                                            <Text style={{ fontSize: 10 }}>DATE PAID</Text>
                                            <View style={{ borderRight: '1px solid black' }} />
                                            <View style={{ textAlign: 'left' }}>
                                                <Text style={{ fontSize: 10 }}>PAID BY</Text>
                                            </View>
                                        </View>
                                        <View
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                height: '25px',
                                                width: '250px',
                                                justifyContent: 'space-between',
                                                border: '1px solid black',
                                                borderLeft: '0px',
                                            }}
                                        >
                                            <Text style={{ fontSize: 10 }}>AMOUNT</Text>
                                            <View style={{ borderRight: '1px solid black' }} />
                                            <View style={{ textAlign: 'left' }}>
                                                <Text style={{ fontSize: 10 }}>CHECK NUMBER</Text>
                                            </View>
                                        </View>
                                        <View
                                            style={{
                                                height: '25px',
                                                width: '250px',
                                                textAlign: 'left',
                                                border: '1px solid black',
                                                borderLeft: '0px',
                                                borderTop: '0px',
                                            }}
                                        >
                                            <Text style={{ fontSize: 10, marginLeft: '10px' }}>NOTE</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>

                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                </Document>
            </ReactPDF.PDFViewer>
        </Dialog>
    );
};

export default SaltwerxOOP;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/OOPTemplates/SaltwerxOOP.tsx